<template>
  <div>
    <div v-if="documentsObject">
      <view-file-item
        class="is-border"
        ref="viewFileItem"
        v-if="displayDocument(documentsObject)"
        :index="index"
        :key="index + '-document'"
        :document="documentsObject"
        :can-drag="canDrag"
        :from-flux="fromFlux"
        :can-edit="canEdit"
        :edit-display-enabled="editDisplayEnabled"
        @update="updateDocument"
        @delete="deleteDocument"></view-file-item>
    </div>
    <div
      v-dragula="documents"
      drake="one"
      v-else-if="canDrag">
      <template v-for="(document, index) in documents">
        <view-file-item
          class="is-border"
          ref="viewFileItem"
          v-if="displayDocument(isArray ? document : document.document)"
          :index="index"
          :key="'' + document.cloudinary_id + index"
          :document="isArray ? document : document.document"
          :can-drag="canDrag"
          :from-flux="fromFlux"
          :can-edit="canEdit"
          :edit-display-enabled="editDisplayEnabled"
          @update="updateDocument"
          @delete="deleteDocument"></view-file-item>
      </template>
    </div>
    <div v-else-if="!canDrag">
      <template v-for="(document, index) in documents">
        <view-file-item
          class="is-border"
          ref="viewFileItem"
          v-if="displayDocument(isArray ? document : document.document)"
          :index="index"
          :key="'' + document.cloudinary_id + index"
          :document="isArray ? document : document.document"
          :can-drag="canDrag"
          :from-flux="fromFlux"
          :can-edit="canEdit"
          :edit-display-enabled="editDisplayEnabled"
          @update="updateDocument"
          @delete="deleteDocument"></view-file-item>
      </template>
    </div>
  </div>
</template>

<script>
import ViewFileItem from './ViewFileItem'
import { mapGetters } from 'vuex'

export default {
  name: 'ViewFileList',
  components: { ViewFileItem },
  props: {
    ...ViewFileItem.props,
    documents: Array,
    documentsObject: Object,
    isArray: Boolean
  },
  data () {
    return {
      documentCopy: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  methods: {
    /**
       * show document
       * @param {object} document
       * @returns {boolean}
       */
    displayDocument (document) {
      return document && (this.isAdmin || ('destination' in document && document.destination && document.destination.includes('display_in_adv')))
    },
    // openPreview (selectedDocument) {
    //   let params = {
    //     source: selectedDocument
    //   }
    //   this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
    // },
    /**
       * update document
       * @param {object} document
       * @param {number} index
       */
    updateDocument ({ document, index }) {
      if (this.documents) {
        let documents = this.documents
        if (this.isArray) {
          this.$set(documents, [index], document)
        } else {
          this.$set(documents[index], 'document', document)
        }
        this.$emit('update', documents)
      } else if (this.documentsObject) {
        let documents = this.documentsObject
        documents = document
        this.$emit('update', documents)
      }
    },
    /**
       * delete document
       * @param {number} index
       */
    deleteDocument ({ index }) {
      if (this.documents) {
        let documents = this.documents
        if (this.isArray) {
          documents.splice(index, 1)
        } else {
          this.$set(documents[index], 'document', null)
        }
        this.$emit('update', documents)
      } else if (this.documentsObject) {
        let documents = this.documentsObject
        documents = null
        this.$emit('update', documents)
      }
    }
  }
}
</script>
